import { useState, useEffect } from 'react';
import apiService, { getStorageUrl } from '../../../../services/apiService';
import { useTenant } from '../../../../contexts/TenantContext';

const ThrowballGoverningBody = () => {
  const { siteSettings } = useTenant();
  const [pageData, setPageData] = useState({
    title: 'Governing Body',
    members: []
  });
  const [loading, setLoading] = useState(true);

  // Static/Default members - shown when no dynamic data exists
  const staticMembers = [
    { id: 1, name: 'Mahabali Satpal', post: 'Chief Patron', image: '/theme/assets/images/Mahabal-Satpal-home-img.png' },
    { id: 2, name: 'Ashok Nete', post: 'President', image: '/theme/assets/images/Ashok-Nete-home-img.png' },
    { id: 3, name: 'Vishvas Sarang', post: 'Vice President', image: '/theme/assets/images/Dr-Vishwas-Sarang-home-img.png' },
    { id: 4, name: 'Karam Singh', post: 'General Secretary', image: '/theme/assets/images/Karam-Singh-home-img.png' },
    { id: 5, name: 'J. L. Khurana', post: 'Treasurer', image: '/theme/assets/images/J-L-Khurana-home-img.png' },
    { id: 6, name: 'T. Balavinayakam', post: 'Joint Secretary', image: '/theme/assets/images/T-Balavinayakam-home-img.png' },
    { id: 7, name: 'Bala Bachchan', post: 'Vice President', image: '/theme/assets/images/Bala-Bachchan-home-img.png' },
    { id: 8, name: 'Sanjay Pande', post: 'Executive Member', image: '/theme/assets/images/Sanjay-Pande-home-img.png' },
    { id: 9, name: 'M. U. Murarkar', post: 'Executive Member', image: '/theme/assets/images/M-U-Murarkar-home-img.png' },
    { id: 10, name: 'Avinash Burbure', post: 'Executive Member', image: '/theme/assets/images/Avinash-Burbure-home-img.png' }
  ];

  useEffect(() => {
    fetchPageData();
  }, []);

  const fetchPageData = async () => {
    try {
      setLoading(true);
      const response = await apiService.get('/public/site-settings');
      const data = response.data;

      if (data.success && data.data) {
        let members = [];

        // First try to get members from the members array (new format)
        if (data.data.governing_body_members && Array.isArray(data.data.governing_body_members) && data.data.governing_body_members.length > 0) {
          members = data.data.governing_body_members.map((m, index) => ({
            id: m.id || index + 1,
            name: m.name || '',
            post: m.post || '',
            image: m.image ? getStorageUrl(m.image) : null
          }));
        }
        // Fallback to parsing text content (legacy format)
        else if (data.data.governing_body_content) {
          members = parseContentToMembers(data.data.governing_body_content);
        }

        setPageData({
          title: data.data.governing_body_title || 'Governing Body',
          members: members.length > 0 ? members : staticMembers
        });
      } else {
        setPageData({
          title: 'Governing Body',
          members: staticMembers
        });
      }
    } catch (error) {
      console.error('Error fetching governing body data:', error);
      setPageData({
        title: 'Governing Body',
        members: staticMembers
      });
    } finally {
      setLoading(false);
    }
  };

  // Parse legacy text content into members array (format: "Name | Post | Image URL")
  const parseContentToMembers = (content) => {
    if (!content) return [];
    return content.split('\n')
      .filter(line => line.trim())
      .map((line, index) => {
        const parts = line.split('|').map(p => p.trim());
        const imagePath = parts[2] || null;
        return {
          id: index + 1,
          name: parts[0] || '',
          post: parts[1] || '',
          image: imagePath ? getStorageUrl(imagePath) : null
        };
      });
  };

  // Default placeholder image for members without photos (simple gray avatar)
  const defaultImage = 'data:image/svg+xml,' + encodeURIComponent(`
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200" fill="#ccc">
      <rect width="200" height="200" fill="#e0e0e0"/>
      <circle cx="100" cy="70" r="40" fill="#bbb"/>
      <ellipse cx="100" cy="170" rx="60" ry="50" fill="#bbb"/>
    </svg>
  `);

  return (
    <section className="tb-page-section tb-governing-body-section">
      <div className="tb-container">
        {/* Top Banner */}
        <div className="tb-page-banner">
          <img src={siteSettings?.page_banners?.['governing-body'] || '/theme/assets/images/banner-3.jpg'} alt="Governing Body Banner" />
        </div>

        {/* Page Content */}
        <div className="tb-page-content">
          <div className="tb-heading-top">
            <h1 className="tb-page-title">{pageData.title}</h1>
            <span className="tb-mini-line"></span>
          </div>

          {loading ? (
            <div style={{ textAlign: 'center', padding: '2rem' }}>
              <p>Loading...</p>
            </div>
          ) : (
            <div className="tb-gov-grid">
              {pageData.members.map((member) => (
                <div className="tb-gov-card" key={member.id}>
                  {/* Member Photo with circular pink gradient background */}
                  <div className="tb-member-img-wrapper">
                    <img
                      src={member.image || defaultImage}
                      alt={member.name}
                      className="tb-member-img"
                      onError={(e) => {
                        e.target.src = defaultImage;
                      }}
                    />
                  </div>
                  {/* Member Info */}
                  <div className="tb-gov-info">
                    <h3 className="tb-gov-name">{member.name}</h3>
                    <p className="tb-gov-post">{member.post}</p>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default ThrowballGoverningBody;
